<template>
  <div class="section-blog">
    <div class="container">
      <div class="breadcrumb-sorted-block">
        <ui-breadcrumbs></ui-breadcrumbs>
      </div>
      <div class="header">
        <div class="great-title">
          <h1>{{ titlepage }}</h1>
        </div>
      </div>
      <div>
        <div class="content rich-text">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import uiBreadcrumbs from '@/components/ui/ui-breadcrumbs'
export default {
    components: {
        uiBreadcrumbs
    },
    props: {
        titlepage: ""
    },
  data() {
    return {
      opened: false
    }
  },
    mounted(){
        document.querySelector('.doH1').remove();
    }
}
</script>

<style lang="scss" scoped>
.section-blog {
  padding-bottom: 5em;
  position: relative;
  .breadcrumb-sorted-block{
    margin-left: 20px;
  }
  a{
    color: #21498A !important;
    text-decoration: underline !important;
  }
}
.container {
 /* display: grid;
  grid-template-columns: 18em 47.5em;
  grid-gap: 4em;*/
  div:first-child{
    max-width: 800px;
    margin: 0 auto;
  }
}
.content {
  margin-top: 2em;
}
@media screen and (max-width: 767px) {
  .container {
    display: block;
  }
}
</style>
<style>
  .w300{
    width: 300px;
  }
</style>
